import { Button, Card, Stack, Typography } from "@mui/material";
import { useCancelBroadbandScheduled } from "@features/CancelBroadband/CancelBroadbandScheduled/useCancelBroadbandScheduled";
import { useTranslation } from "react-i18next";
import { CancelBroadbandError } from "@features/CancelBroadband/CancelBroadbandError/CancelBroadbandError";
import { useDeviceType } from "@hook/useDeviceType";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { ConfirmationModal } from "@common/ConfirmationModal/ConfirmationModal";

interface IParams {
    scheduledAt: string;
}

export const CancelBroadbandScheduled = (props: IParams) => {
    const { scheduledAt } = props;
    const { isMobile } = useDeviceType();
    const { t } = useTranslation("cancelBroadband");
    const { handleUndoCancellation, error, isLoading, isModalOpen, setIsModalOpen } = useCancelBroadbandScheduled();

    return (
        <>
            <HandleErrorAndLoading
                error={error}
                errorComponent={<CancelBroadbandError />}
                hideComponentWrapper
                isLoading={isLoading}
            >
                <Card>
                    <Stack gap={5} padding={5} textAlign="center">
                        <Typography color="primary" variant="h2">
                            {t("scheduled.cancellationScheduled")}
                        </Typography>
                        <Typography color="secondary" variant="normal">
                            {t("scheduled.broadbandEndsOn", { scheduledAt })}
                        </Typography>
                        <div>
                            <Button
                                color="primary"
                                fullWidth={isMobile}
                                variant="contained"
                                onClick={() => setIsModalOpen(true)}
                            >
                                {t("scheduled.undoCancellation")}
                            </Button>
                        </div>
                    </Stack>
                </Card>
            </HandleErrorAndLoading>
            {isModalOpen && (
                <ConfirmationModal
                    cancelLabel={t("scheduled.keepCancellation")}
                    continueLabel={t("scheduled.continueUndo")}
                    isLoading={isLoading}
                    isModalOpen={isModalOpen}
                    subtitle={t("scheduled.continueAsNormal")}
                    title={`${t("scheduled.undoCancellation")}?`}
                    onClose={() => setIsModalOpen(false)}
                    onContinue={handleUndoCancellation}
                />
            )}
        </>
    );
};
